// test2460
(2460 && 0);
